<template>
  <v-layout style="height: 55px" class="guac-layout-header">
    <v-app-bar
      app
      height="55"
      class="px-1"
      color="#f6f5fb"
      :style="{ backgroundColor: 'rgb(246, 245, 251)' }"
      elevate-on-scroll
    >
      <v-app-bar-nav-icon
        id="layout-menu-button"
        class="toggle-menu-button"
        icon="mdi-dots-grid"
        size="small"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer id="sidebar" v-model="drawer" width="300" app temporary color="white">
      <div class="bar"></div>
      <div class="getwell-name text-h4 pl-6 pt-7 pb-2 px-2">Get Well</div>
      <v-list class="d-flex flex-column px-2" dense nav>
        <template v-for="(item, index) in navOptions" :key="index">
          <menu-item
            v-if="'launchPoint' in item"
            :key="index"
            :title="item.title"
            :icon="item.icon"
            :id-suffix="item.path"
            @click="navigate(item.launchPoint, item.isRedirect)"
          >
          </menu-item>
          <v-list-group v-else :value="item.name">
            <template #activator="{ props: groupProps }">
              <menu-item
                v-bind="{ class: groupProps.class, onClick: groupProps.onClick }"
                :key="item.name + index"
                :title="item.name"
                :icon="item.icon"
                :id-suffix="item.name + '-group'"
              >
              </menu-item>
            </template>
            <menu-item
              v-for="(groupItem, groupItemIndex) in item.items"
              :key="groupItemIndex"
              :title="groupItem.title"
              :icon="groupItem.icon"
              :id-suffix="groupItem.path"
              @click="navigate(groupItem.launchPoint, groupItem.isRedirect)"
            >
            </menu-item>
          </v-list-group>
        </template>

        <v-spacer class="pt-4"></v-spacer>
        <v-list-item
          id="layout-menu-item-logout"
          class="sidebar-nav-option"
          :style="{ color: palette.gwDarkPurple }"
          @click="logout"
        >
          <div class="d-flex align-center py-1">
            <div class="v-list-item-icon">
              <div class="navigation-icon elevation-1 rounded-circle d-flex justify-center align-center">
                <v-icon color="#5F6369">mdi-logout</v-icon>
              </div>
            </div>
            <div class="ml-2 v-list-item-content">
              <v-list-item-title>Logout</v-list-item-title>
            </div>
          </div>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-layout>
</template>

<script setup lang="ts">
import { ref } from "vue";
import useInterface from "../helpers/useInterface";
import MenuItem from "./MenuItem.vue";
import { NavigationRow } from "../types";
import palette from "@/guac-layout/styles/variables.module.scss";
// import "../App.scss";

interface Props {
  navOptions: NavigationRow[];
}

const props = defineProps<Props>();
const drawer = ref(false);
const auth = useInterface("authInterface");
const navOptions = props.navOptions || useInterface("navOptions");

const navigate = (url: string, redirect: boolean) => {
  if (redirect) {
    // Nav Option may be a site that lives outside of GUAC boundary
    // ex: Inpatient Management Console
    // ex: Loop Admin
    window.open(url, "_blank");
  } else {
    window.history.pushState({}, "", url);
    drawer.value = false;
  }
};

const logout = () => {
  auth.logout();
};
</script>
<style lang="scss">
.guac-layout-header {
  position: relative;
  z-index: 99999 !important;

  #sidebar {
    border: none !important;
  }
  .bar {
    width: 100%;
    height: 32px;
    background-color: $gw-dark-purple;
  }
  .v-list-item-icon {
    .v-btn {
      pointer-events: none;
    }
  }
  .v-list-item-content {
    user-select: none;
  }
  .getwell-name {
    font-family: $font-serif !important;
    color: $gw-dark-purple;
    font-weight: normal;
    letter-spacing: normal !important;
  }
  .v-list {
    min-height: calc(100% - 120px);
    color: $gw-dark-purple !important;
  }
  .v-list-item-title {
    font-size: 1em !important;
    font-weight: normal;
    font-family: $font-sanserif !important;
    color: $gray !important;
  }
  .v-app-bar-nav-icon {
    &:hover {
      background-color: rgba(227, 221, 243, 1) !important;
    }
  }
  .v-app-bar .v-btn {
    margin: 0px;
  }
  .v-list-group__items .v-list-item {
    padding-left: 2em !important;
  }
  .navigation-icon {
    width: 48px;
    height: 48px;
  }
}
</style>
